import { RouteRecordRaw } from "vue-router";

/**
 * Global object to store shared data between app.
 * Can avoid circular references.
 */
export default {
  routes: [] as RouteRecordRaw[],
};
